import {
  jdmsDetail,
  jdmsDetailEdit,
  jdmsCategoryProps,
  jdmsSalePropRule,
  jdmsBrandList,
  jdmsShopCategory,
  jdmsReturnSpecCategoryPropsValue,
  jdmsSpecCategoryProps,

} from '@/api/prod/center'
import store from '@/store'

// 过滤上传失败或为空的图片
export function _filterInvalidImg (imgsArr) {
  return imgsArr.filter(img => {
    if (!img) {
      return false
    } else if (typeof img === 'object') {
      return false
    } else {
      return true
    }
  })
} 

// 格式化每个商品数据
// isRequest 格式化发送请求数据 --- 默认是格式化响应请求的数据
export function _formatGoodsItem(r, isRequest) {
  if (r.skuList && r.skuList.length > 0) {
    r.skuList = r.skuList.map(item => {
      return isRequest ? {
        ...item,
        skuSpecifications: JSON.stringify(item.skuSpecifications ? item.skuSpecifications : []),
        promiseConfig: JSON.stringify(item.promiseConfig ? item.promiseConfig : []),
        skuPropValues: JSON.stringify(item.skuPropValues ? item.skuPropValues : []),
      } : {
        ...item,
        skuSpecifications: item.skuSpecifications ? JSON.parse(item.skuSpecifications) : [],
        promiseConfig: item.promiseConfig ? JSON.parse(item.promiseConfig) : [],
        skuPropValues: item.skuPropValues ? JSON.parse(item.skuPropValues) : [],
      }
    })
  }
   // 处理长图数据，过滤掉对象格式的图片项
   const formatLengthImages = (images) => {
      if (!Array.isArray(images)) return [];
      return images.map(item => ({
        ...item,
        imageUrls: Array.isArray(item.imageUrls) 
          ? item.imageUrls.filter(url => typeof url === 'string')
          : []
      }));
    };

  return isRequest ? {
    ...r,
    itemPropValues: JSON.stringify(r.itemPropValues ? r.itemPropValues : []),
    images: JSON.stringify(r.images ? r.images : []),
    lengthImages: JSON.stringify(r.lengthImages ? formatLengthImages(r.lengthImages) : []),
    transparentImages: JSON.stringify(r.transparentImages ? r.transparentImages : []),
    specificationNames: JSON.stringify(r.specificationNames ? r.specificationNames : []),
    specifications: JSON.stringify(r.specifications ? r.specifications : []),
    specSkuImage: JSON.stringify(r.specSkuImage ? r.specSkuImage : []),
    searchImages: JSON.stringify(r.searchImages ? r.searchImages : []),
    categoryIds: r.categoryIds ? r.categoryIds.join(',') : '',
    brandId: JSON.stringify(r.brandId ? r.brandId : []),
  } : {
    ...r,
    itemPropValues: r.itemPropValues ? JSON.parse(r.itemPropValues) : [],
    images: r.images ? JSON.parse(r.images) : [],
    // lengthImages: r.lengthImages ? JSON.parse(r.lengthImages) : [],
    lengthImages: r.lengthImages ? formatLengthImages(JSON.parse(r.lengthImages)) : [],
    transparentImages: r.transparentImages ? JSON.parse(r.transparentImages) : [],
    specificationNames: r.specificationNames ? JSON.parse(r.specificationNames) : [],
    specifications: r.specifications ? JSON.parse(r.specifications) : [],
    specSkuImage:r.specSkuImage ? JSON.parse(r.specSkuImage) : [],
    searchImages:r.searchImages ? JSON.parse(r.searchImages) : [],
    categoryIds: r.categoryIds ? r.categoryIds.split(',') : [],
    templateConfig: r.templateConfig ? JSON.parse(r.templateConfig) : [],
    brandId: r.brandId ? JSON.parse(r.brandId) : [],
    promiseConfig: r.promiseConfig ? JSON.parse(r.promiseConfig) : [],
  }
}

// 编辑详情
export function editJdmsDetail(data) {
  return jdmsDetailEdit(_formatGoodsItem(data, true)).then(res => {
    if (res.result === 1) {
      return true
    } else {
      return false
    }
  })
}

// 获取详情资料
export function getJdmsDetail(baseItemId,companyId) {
  return jdmsDetail({
    baseItemId,
    companyId,
  }).then(res => {
    if (res.result === 1) {
      // debugger;
      return _formatGoodsItem(res.data)
    } else {
      return false
    }
  })
}
// 获取品牌
export function getJdmsBrandList(shopId) {
  return jdmsBrandList({
    shopId,
  }).then(res => {
    if (res.result === 1) {
      return res.data
    } else {
      return false
    }
  })
}
// 获取店铺分类
export function getJdmsShopCategory(shopId) {
  return jdmsShopCategory({
    shopId,
  }).then(res => {
    if (res.result === 1) {
      return res.data
    } else {
      return false
    }
  })
}
// 获取商品属性
export function getJdmsCategoryProps(shopId,categoryId){
  return jdmsCategoryProps({
    shopId,
    categoryId
  }).then(res => {
    if (res.result === 1) {
      return res.data
    } else {
      return false
    }
  })
}
// 获取销售属性
export function getJdmsSalePropRule(shopId,categoryId){
  return jdmsSalePropRule({
    shopId,
    categoryId
  }).then(res => {
    if (res.result === 1) {
      return res.data
    } else {
      return false
    }
  })
}
// 查询退货标签
export function getjdmsReturnSpecCategoryPropsValue(shopId,categoryId){
  return jdmsReturnSpecCategoryPropsValue({
    shopId,
    categoryId
  }).then(res => {
    if (res.result === 1) {
      return res.data
    } else {
      return false
    }
  })
}

export function getJdmsSpecCategoryProps(shopId,categoryId,code){
  return jdmsSpecCategoryProps({
    shopId,
    categoryId,
    code
  }).then(res => {
    if (res.result === 1) {
      return res.data
    } else {
      return false
    }
  })
}